import React from 'react';

const ThemeContext = React.createContext({
    themeContext: {
        configHeader: () =>
        {},
        loadRegions: () =>
        {},
        setHeightChange: (f) =>
        {},
        headerPhoneNumber: () =>
        {},
    },
});

export default ThemeContext;
